import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

export default function DeleteOrderButton({
  onDelete,
  rowsSelected,
}) {
  const onDeleteOrders = async () => {
    if (window.confirm(`確定要刪除這${rowsSelected.length}筆訂單?`)) {
      onDelete && onDelete(rowsSelected);
    }
  };

  return (
    <Button
      style={ { marginLeft: 10 } }
      variant="contained"
      color="primary"
      onClick={async () => {
        onDeleteOrders();
      }}
    >
      刪除訂單
    </Button>
  );
}


DeleteOrderButton.propTypes = {
  onDelete: PropTypes.func,
  rowsSelected: PropTypes.array,
};
